/**
 * AI:
 * Status: "confirmed"
 * Type: Component
 * SubType: CrudIntegration
 * Reason: ObjectBaseComponent for LogicFlowTestCase entity — displays active/last-run status badges and generic CRUD form.
 */
import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ConfirmationService} from 'primeng/api';
import {ObjectBaseComponent} from '../../../../../core/shared/object/mvs-object-base/object-base.component';
import {MvsCoreService} from '../../../../../core/shared/service/mvs-core.service';
import {MvsMessageService} from '../../../../../core/shared/service/message/mvs-message.service';
import {ObserverService} from '../../../../../core/shared/object/service/observer.service';
import {LogicFlowTestCaseDto} from '../../../model/dto/entity/logic-flow-test-case.dto';

@Component({
    selector: 'mvs-lg-logic-flow-test-case-object-component',
    templateUrl: './lg-logic-flow-test-case-object.component.html',
    styleUrls: ['./lg-logic-flow-test-case-object.component.scss'],
    standalone: false
})
export class LgLogicFlowTestCaseObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    dto: LogicFlowTestCaseDto;

    /** Active status display metadata */
    activeLabel: string = '';
    activeSeverity: 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast' = 'secondary';

    /** Last run display metadata */
    lastRunLabel: string = '';
    lastRunSeverity: 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast' = 'secondary';

    constructor(
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected confirmationService: ConfirmationService,
        protected override observerService: ObserverService
    ) {
        super(coreService, messageService, confirmationService, observerService);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    onObjectChanged() {
        this.updateActiveMeta();
        this.updateLastRunMeta();
    }

    /**
     * Derive active status display metadata.
     */
    private updateActiveMeta(): void {
        if (this.dto.active) {
            this.activeLabel = 'Aktiv';
            this.activeSeverity = 'success';
        } else {
            this.activeLabel = 'Inaktiv';
            this.activeSeverity = 'danger';
        }
    }

    /**
     * Derive last run display metadata from lastRunSuccess.
     */
    private updateLastRunMeta(): void {
        if (this.dto.lastRunSuccess === true) {
            this.lastRunLabel = 'Bestanden';
            this.lastRunSeverity = 'success';
        } else if (this.dto.lastRunSuccess === false) {
            this.lastRunLabel = 'Fehlgeschlagen';
            this.lastRunSeverity = 'danger';
        } else {
            this.lastRunLabel = 'Nicht ausgeführt';
            this.lastRunSeverity = 'secondary';
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
